import { render, staticRenderFns } from "./ReverseBase.vue?vue&type=template&id=37576940&scoped=true&"
import script from "./ReverseBase.vue?vue&type=script&lang=ts&"
export * from "./ReverseBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37576940",
  null
  
)

export default component.exports